import React from 'react'
import MapBox from './MapBox'
import Markers from './Markers'
import Compass from './Compass'
import MapTools from './MapTools'
import { string, bool } from 'prop-types'

const Map = ({ height, width, fitBounds }) => (
  <MapBox height={height} width={width} fitBounds={fitBounds}>
    <Markers />
    <Compass />
    <MapTools />
  </MapBox>
)

Map.propTypes = {
  height: string.isRequired,
  width: string.isRequired,
  fitBounds: bool.isRequired,
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Map/index.jsx